import React from 'react';
import { CopyIcon } from '../../assets/icons/Icons';
import "../../assets/scss/components/copyable-text.scss"

const CopyableText = (props) => {

    const copyText = (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(props.text);
    }

    return (
        <span className="copyable-text">{props.text || '-'}
            {props.text && <span className="copyable-text__icon" onClick={copyText}><CopyIcon/></span> }
        </span>
    );
};

export default CopyableText;
